import * as React from 'react';

import { PostCommentsHeader } from '../../components/PostCommentsHeader';
import { mkCommentListState } from '../../__stubs__/mocks/commentList';
import { PostCommentForm } from '../../components/PostCommentForm';

export const PostCommentsContainer = () => {
  const {
    meta: { total },
  } = mkCommentListState();

  return (
    <>
      <PostCommentsHeader commentsCount={total} />
      <PostCommentForm onChange={() => {}} onSubmit={() => {}} value={'1'} />
    </>
  );
};
